/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { Box, Flex, IconDownload, Image, Link, Text } from "@powerledger/ui-component-lib";
import { kebabCase } from "lodash";
import { useTranslation } from "react-i18next";

import { ResourceType } from "../../user-resources.types";

export const ResourceTile = ({ url, name, image, expired }: ResourceType) => {
  const { t } = useTranslation();
  const testid = kebabCase(`${expired ? "expired" : "active"}-${name}`);
  return (
    <Flex sx={{ pb: 4 }} data-testid={testid}>
      <Image src={image} alt={name + " image"} sx={{ height: 200 }} />
      <Box sx={{ justifyContent: "flex-end", pl: 2 }}>
        <Text sx={{ fontFamily: "MintGroteskV08", fontWeight: "bold", fontSize: 3 }}>{t(name)}</Text>
        <Link
          href={url}
          download
          target="_blank"
          sx={{
            color: "accent",
            cursor: "pointer",
            "&:hover": { textDecoration: "underline" },
            display: "flex",
            alignItems: "center",
            mt: 2,
          }}
          aria-label={t(`Download {{name}}{{expired}}`, { name, expired: expired ? " Expired" : "" })}
          data-testid={kebabCase(`download-${testid}`)}
        >
          <IconDownload size={4} sx={{ ml: -1 }} />
          <Box sx={{ fontSize: 1, ml: 1, letterSpacing: 1.5 }}>{t("DOWNLOAD")}</Box>
        </Link>
      </Box>
    </Flex>
  );
};
